export default "__VITE_ASSET__bbc56413__"